export const classes = {
  icon: 'mr-3 text-base',
  button: 'text-grey-7 hover:text-grey-8',
};
